export enum WithdrawalSourcingMode {
  Generic = 0,
  // 1 was Specific — retired, not to be reused.
  Automatic = 2,
}
